module.exports = __webpack_public_path__ + "img/pieces-auto-super.42ae319f.png";